module.exports = __webpack_public_path__ + "assets/icon-widget.3d53c21c.svg";